import React, { useState } from 'react'
import {Button, Dimmer, Form, Header, Icon, Loader, Message} from "semantic-ui-react";
import SimpleReactValidator from 'simple-react-validator';

const EmailValidation = (props) => {
    const getTerm = props.getTerm;

    const [errorString, setError] = useState();
    const [emailAddress, setEmailAddress] = useState("");
    const [confirmationCode, setConfirmationCode] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [confirmError, setConfirmError] = useState(false);
    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();

    // React.useEffect(() => {
    //     if (window.location.hash) {
    //         // Fragment exists
    //         console.log("Hash is " + window.location.hash);

    //         let hashString = window.location.hash.substring(1);

    //         console.log(hashString);

    //         let personID = window.location.hash.substring(1, window.location.hash.indexOf("/"));
    //         let confirmCode = window.location.hash.substring(window.location.hash.indexOf("/") + 1);

    //         if (typeof personID !== "undefined" && typeof confirmCode !== "undefined")
    //         {
    //             setLoading(true);

    //             props.dataManager.validateAuto(personID, confirmCode).then((response) => {
    //                 setLoading(false);
    //                 if (typeof response.data.success !== "undefined") {
    //                     if (response.data.success === 0) {
    //                         setError(response.data.errorMessage);
    //                     } else {
    //                         props.setRequirePassword(response.data.data.requirePassword);
    //                         props.setJwt(response.data.data.jwt);
    //                         props.setStep("terms");
    //                     }
    //                 }
    //                 else
    //                 {
    //                     setLoading(false);
    //                     setError(response.data);
    //                 }
    //             });
    //         }

    //     } else {
    //         // Fragment doesn't exist; do nothing.
    //     }
    // }, []);

    const submitForm = (e) =>
    {
        setError();
        setEmailError(false);
        setConfirmError(false);

        let hasErrors = false;

        if (!validator.check(emailAddress, 'required'))
        {
            setEmailError({ content: getTerm("cc9a7432-d13d-11f0-8346-0ac9221eb135", "Please fill out this field.") });
            hasErrors = true;
        }

        if (!validator.check(confirmationCode, 'required'))
        {
            setConfirmError({ content: getTerm("cc9a7432-d13d-11f0-8346-0ac9221eb135", "Please fill out this field.") });
            hasErrors = true;
        }

        if (!validator.check(emailAddress, 'email'))
        {
            setEmailError({ content: getTerm("c6f613ce-d78c-11f0-9cd9-0ac9221eb135", "Please enter a valid email address.") });
            hasErrors = true;
        }

        if (!validator.check(confirmationCode, 'size:9'))
        {
            setConfirmError({ content: getTerm("0da8a94e-d78d-11f0-9cd9-0ac9221eb135", "Please enter a valid code.") });
            hasErrors = true;
        }

        if (!hasErrors) {
            setLoading(true);

            props.dataManager.validateManual(emailAddress, confirmationCode)
                .then(response => {
                    setLoading(false);
                    if (typeof response.data.success !== "undefined") {
                        if (response.data.success == 0) {
                            setError(response.data.errorMessage);
                        } else {
                            props.setJwt(response.data.data.jwt);
                            props.setRequirePassword(response.data.data.requirePassword);
                            props.setStep("terms");
                        }
                    }
                    else
                    {
                        setError(response.data);
                        setLoading(false);
                    }
                });
        }
        else
        {
            setError(getTerm("c893573c-d13d-11f0-8346-0ac9221eb135", "Please review the fields marked below."));
        }
    }

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>{getTerm("bda913ca-d13d-11f0-8346-0ac9221eb135", "Loading")}</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>{getTerm("2dd541a2-d12d-11f0-8346-0ac9221eb135", "Email Validation")}</Header>
            <div>
                <Message size='tiny' icon info >
                    <Icon name='info circle' />
                    <Message.Content dangerouslySetInnerHTML={{__html: getTerm("5ddc8fcc-d12d-11f0-8346-0ac9221eb135", "<strong>NOTE: </strong>  If you are a new auditor and need to complete prerequisites in the ADP, please ask your sponsoring CB to submit an application to the applicable Training Organization.  For non-auditors/\"free ticket candidates,\" please ask your CB to contact your responsible Oversight Office.")}}>
                    </Message.Content>
                </Message>

                <p>{getTerm("f4e8f752-d12d-11f0-8346-0ac9221eb135", "To validate your email address, please enter it along with the Confirmation Code that was sent to you. Once you've successfully validated your email address, you'll be able to proceed with your registration.")}</p>
                {/* <p>If your Training Organization or Oversight Office indicates that the email has been sent but you do not yet see it, please note that it may take 15 to 30 minutes to appear in your Inbox.  Please also consult your "Spam" or "Junk E-mail" folders, in case the email got moved there inadvertently. If you still haven't received the email notification, you may also have it <a href="#" onClick={(e) => { props.setStep("resend") }}>re-sent</a>.</p> */}
                <p>{getTerm("128f3a14-d13d-11f0-8346-0ac9221eb135", "If your Training Organization or Oversight Office indicates that the email has been sent but you do not yet see it, please note that it may take 15 to 30 minutes to appear in your Inbox.  Please also consult your \"Spam\" or \"Junk E-mail\" folders, in case the email got moved there inadvertently. If you still haven't received the email notification, you may also have it re-sent.")}</p>

                <a href="#" onClick={(e) => { props.setStep("resend");}}>{getTerm("bfe1912e-d144-11f0-8346-0ac9221eb135", "Resend Email")}</a>
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon>
                <Icon name='exclamation' />
                <Message.Content>
                <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                {errorString}
                </Message.Content>
            </Message>
            }

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>
                <Form.Field error={emailError} label={getTerm("029d7c1a-d12e-11f0-8346-0ac9221eb135", "Email Address")} control="input" placeholder="user@domain.com"  onChange={(e) => setEmailAddress(e.target.value)} value={emailAddress} />
                <Form.Field error={confirmError} label={getTerm("09da3bbc-d12e-11f0-8346-0ac9221eb135", "Confirmation Code")} control="input" onChange={(e) => setConfirmationCode((e.target.value))} value={confirmationCode} />
                <div style={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
                    <Button type='submit' primary>{getTerm("d07f78a4-d13d-11f0-8346-0ac9221eb135", "Next Step")}</Button>
                </div>
            </Form>
        </div>
    )
}

export default EmailValidation;